<a
    #anchor
    [id]="anchorId"
    [href]="
        isPushMenuEntry() ? menuEntry?.categoryPath : menuEntry?.path || menuEntry?.categoryPath || menuAboutEntry?.data
    "
    [class.keyboard-navigation]="layoutFacade.keyboardNavigation$ | async"
    [class.white]="shouldShowWhiteText()"
    [class.active]="
        (currentUrl === menuEntryPath && primaryEntry) || (currentUrl === menuAboutEntryPath && primaryAboutEntry)
    "
    [attr.aria-current]="
        (currentUrl === menuEntryPath && primaryEntry ? 'page' : null) ||
        (currentUrl === menuAboutEntryPath && primaryAboutEntry ? 'page' : null)
    "
    [class]="menuLinkLevel"
    (click)="click($event)"
    (keydown.enter)="click($event)"
    (keydown.space)="click($event)"
    [innerHTML]="menuEntry?.name || menuAboutEntry?.label"
    [title]="menuEntry?.name || menuAboutEntry?.label"></a>
